<template>
  <div
    @mouseover="$emit('show')"
    @mouseleave="$emit('hide')"
    class="static-float"
    :style="{ left: left / 100 + 'rem' }"
  >
    <!-- <div class="box">
      <div class="icon">
        <img class="gift-img" :src="gift.animation" alt="fail" v-if="gift.animat_type !== 2" />
        <div v-else id="svg_play" style="width: 100%; height: 100%"></div>
      </div>
      <div class="main">
        <p class="gift-title">{{ gift.title }}</p>
        <div class="money-small">
          <img class="money-icon" src="./img/mine_top_jinkela.png" alt="" />
          <span>{{ gift.price }}</span>
        </div>
      </div>
      <div class="gift-text" @click="sendGift">赠送</div>
    </div> -->
    <div class="box-up">
      <div class="icon">
        <img class="gift-img" :src="gift.icon" alt="fail" />
        <img
          class="gift-noble"
          v-show="userInfo.noble_id === 1"
          src="./img/knight.png"
          alt=""
        />
        <img
          class="gift-noble"
          v-show="userInfo.noble_id === 2"
          src="./img/duke.png"
          alt=""
        />
        <img
          class="gift-noble"
          v-show="userInfo.noble_id === 3"
          src="./img/emperor.png"
          alt=""
        />
        <!-- <div v-else id="svg_play" style="width: 100%; height: 100%" :src="gift.animation"></div> -->
      </div>
      <div class="gift-info">
        <div class="first text-overflow">
          {{ gift.title }}
          <span v-show="gift.price_type == 2"
            >{{ gift.price / 100 }}{{ $t("common.diamondText") }}</span
          >
          <span v-show="gift.price_type == 1"
            >{{ gift.price / 100 }}{{ $t("common.gold") }}</span
          >
          <span v-show="userInfo.noble_id > 0">
            ({{ userInfo.gift_discount / 10 + "折" }})</span
          >
        </div>
        <div class="second">{{ $t("pcLive.words") }}</div>
        <div class="third" v-show="gift.animat_type > 0">
          {{ $t("pcLive.send") }}<span>{{ $t("pcLive.one") }}</span
          >{{ $t("pcLive.animate") }}
        </div>
        <!-- <div class="forth">赠送满<span>40个</span>触发世界横幅</div> -->
      </div>
    </div>
    <!-- <div class="box-down" v-show="gift.animat_type === 0" @click="sendGift">
      <div
        class="btn"
        :class="active == 1 ? 'btn-active' : ''"
        @click="changeNum(1)"
      >
        1
      </div>
      <div
        class="btn"
        :class="active == 10 ? 'btn-active' : ''"
        @click="changeNum(10)"
      >
        10
      </div>
      <div
        class="btn"
        :class="active == 66 ? 'btn-active' : ''"
        @click="changeNum(66)"
      >
        66
      </div>
      <div
        class="btn"
        :class="active == 1314 ? 'btn-active' : ''"
        @click="changeNum(1314)"
      >
        1314
      </div>
      <div class="btn btn-send">{{ $t("pcLive.send") }}</div>
    </div> -->
    <div class="box-down" @click="sendGift">
      {{ sendGiftText }}
    </div>
    <div class="bottom-arrow">
      <img :src="require('@/assets/live/arrow.png')" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "static-float",
  props: {
    gift: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    scrollNum: {
      type: Number,
      default: 0,
    },
    transformNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      sendNum: [1, 10, 66, 88, 100, 520, 1314],
      activeNum: 1,
      player: null,
      active: 1,
      sendGiftText: this.$t("pcLive.send"),
      isSend: false,
    };
  },
  watch: {
    gift(newVal) {
      this.activeNum = 1;
      if (this.player) {
        this.player.stopAnimation();
        this.player.clear();
        this.player = null;
        this.parser = null;
      }
      this.$nextTick(() => {
        if (newVal.animat_type === 2) {
          // this.playSvg();
        }
      });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    left() {
      // let right = 0
      let ind = 0;
      // let mod = (this.transformNum + 1) * 8
      // if ((this.index + 1) % (mod - 1) === 0 || (this.index + 1) % mod === 0) {
      //   right = 1
      // } else {
      //   right = 0
      // }
      if (this.transformNum > 0) {
        ind = this.index - this.transformNum * 8;
      } else {
        ind = this.index;
      }
      // return -58%this.index
      return -120 + ind * 55;
    },
  },
  beforeDestroy() {
    this.$off("sendGift");
    this.player = null;
  },
  mounted() {
    // if (this.gift.animat_type === 2) this.playSvg();
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    changeNum(index) {
      this.active = index;
      this.activeNum = index;
    },
    playSvg() {
      if (!this.player) {
        this.player = new this.$SVGA.Player("#svg_play");
        this.parser = new this.$SVGA.Parser("#svg_play");
      }
      this.player.clear();
      this.parser.load(this.genImgUrl2(this.gift.animation), (videoItem) => {
        if (!this.player) return;
        this.player.setVideoItem(videoItem);
        this.player.startAnimation();
      });
    },
    genImgUrl2(url) {
      if (!url) return url;
      return url.indexOf("http") >= 0 ? url : this.appConfig.site_domain + url;
    },
    sendGift() {
      if (this.userInfo.id) {
        if (this.isSend) return;
        this.$emit("sendGift", this.activeNum, this.gift);
        this.isSend = true;
        let time = 3;
        this.sendGiftText = this.$t("pcLive.left") + time + "s";
        this.timeId = setInterval(() => {
          time--;
          this.sendGiftText = this.$t("pcLive.left") + time + "s";
          if (time <= 0) {
            this.sendGiftText = this.$t("pcLive.send");
            this.isSend = false;
            clearInterval(this.timeId);
          }
        }, 1000);
      } else {
        this.toggleLogin();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.static-float {
  position: absolute;
  right: -0.17rem;
  bottom: 0.8rem;
  width: 3.44rem;
  z-index: 99;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;

  .box-up {
    /* height: 1.15rem; */
    padding: 0.16rem 0.2rem 0.1rem;
    display: flex;
    .icon {
      width: 0.48rem;
      // background: #f5f5f7;
      margin-right: 0.12rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .gift-img {
        height: 0.48rem;
        width: 0.48rem;
        border: 0.01rem solid #eee;
        border-radius: 0.03rem;
      }
      .gift-noble {
        width: 0.4rem;
        height: 0.17rem;
        margin-top: 0.05rem;
      }
    }
    .gift-info {
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      color: #333;
      font-weight: 500;
      span {
        color: rgba(208, 45, 84, 1);
      }
      .first {
        font-size: 0.16rem;
        // font-weight: bold;
        padding: 0.04rem 0;
      }
      .second {
        color: #999;
        margin-top: 0.12rem;
      }
      .third {
        margin-top: 0.15rem;
      }
    }
  }
  .box-down {
    height: 0.42rem;
    background: linear-gradient(90deg, #ff2b2b 2.87%, #d02d54 85.95%);
    line-height: 0.42rem;
    text-align: center;
    border-radius: 0 0 8px 8px;
    cursor: pointer;
    color: #fff;
  }
  .bottom-arrow {
    position: absolute;
    bottom: -0.2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.13rem;
    height: 0.16rem;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .box {
    height: 94px;
    display: flex;
    align-items: flex-end;

    .icon {
      width: 70px;
      height: 94px;
      background: #f5f5f7;
      border-radius: 4px;
      margin-right: 16px;

      .gift-img {
        height: 100%;
        width: 100%;
      }
    }

    .main {
      flex: 1;
      height: 100%;
      padding: 11px 0 10px;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .gift-title {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .money-small {
      font-size: 20px;
      color: rgba(208, 45, 84, 1);
      line-height: 24px;
      font-weight: 500;
      display: flex;
    }

    .money-icon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    .gift-text {
      width: 64px;
      height: 24px;
      background: rgba(208, 45, 84, 1);
      border-radius: 12px;
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 13px;
      margin-left: 16px;
      cursor: pointer;
    }
  }
}
</style>
